import types from '../../constants';

let playTimer = 0;

const sendMessage = (type, message) => {
  if (global.socket) {
    global.socket.emit(type, message);
  } else {
    console.warn('Socket not connected, cannot send message:', type, message);
  }
};

export function fetchExercise(exerciseId) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_LOADING_START });
    sendMessage('exercise_join', { id: exerciseId });
  };
}

export function fetchExerciseOk(data) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_LOAD, payload: data });
    dispatch({ type: types.EXERCISE_LOADING_END });
  };
}

export function leaveExercise(exerciseId) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_CLEAR });
    sendMessage('exercise_left', { id: exerciseId });
  };
}

export function userJoined(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.EXERCISE_USER_JOINED,
      payload: data,
      state: getState(),
    });
  }
}

export function userLeft(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.EXERCISE_USER_LEFT,
      payload: data,
      state: getState()
    });
  }
}

export function renameUser(userId, value) {
  return async (dispatch) => {
    dispatch({ type: types.SOCKET_ACTION });
    sendMessage('user_rename', { id: userId, name: value });
  };
}

export function userRenameOk(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.EXERCISE_RENAME_USER,
      payload: data,
      state: getState()
    });
  }
}

export function kickUser(userId) {
  return async (dispatch) => {
    dispatch({ type: types.SOCKET_ACTION });
    sendMessage('user_kick', { id: userId });
  };
}

export function userStatusUpdate(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.EXERCISE_USER_STATUS_CHANGE,
      payload: data,
      state: getState()
    });
  }
}

export function run(exerciseId) {
  return async (dispatch) => {
    dispatch({ type: types.SOCKET_ACTION });
    sendMessage('exercise_play', { id: exerciseId });
  };
}

export function setBenchmark(benchmark) {
  return {
    type: types.EXERCISE_SET_BENCHMARK,
    payload: benchmark
  }
}


export function playStart(data) {
  return async (dispatch, getState) => {
    dispatch({ type: types.EXERCISE_PLAY_START, payload: data });

    if (!playTimer) {
      playTimer = setInterval(() => dispatch({type: types.EXERCISE_PLAY_UPDATE_TIME, state: getState()}), 1000);
    }
  };
}

export function playPause(data) {
  return async (dispatch) => {
    dispatch({ type: types.EXERCISE_PLAY_PAUSE, payload: data });

    clearInterval(playTimer);
    playTimer = 0;
  };
}

export function statusChange(status) {
  return {
    type: types.EXERCISE_STATUS_CHANGE,
    payload: status,
  };
}

export function setState(state) {
  return {
    type: types.EXERCISE_SET_STATE,
    payload: state,
  };
}

export function userLocationUpdate(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.EXERCISE_LOCATION_UPDATE,
      payload: data,
      state: getState(),
    });
  }
}

export function textMessage(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.TEXT_MESSAGE,
      payload: data,
      state: getState(),
    });
  }
}

export function audioMessage(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.AUDIO_MESSAGE,
      payload: data,
      state: getState(),
    })
  }
}

export function audioMessageStatus(data) {
  return function(dispatch, getState) {
    return dispatch({
      type: types.AUDIO_MESSAGE_STATUS,
      payload: data,
      state: getState(),
    })
  }
}

export function clear() {
  return { type: types.EXERCISE_CLEAR };
}
